<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

// The countable facts under a public hero (round-one item 5): the registered
// company and its number, the TAT licence the day it exists, insured
// vessels, the reply promise, no prepayment. Facts come from the shared
// `trust` prop (Public::BaseController) so every page prints the same row.
const { t } = useI18n()
const page = usePage()
const trust = computed(() => page.props.trust || {})

const items = computed(() => {
  const tr = trust.value
  const list = [
    { key: 'company', text: t('public.trust_row.company', { company: tr.company, registration: tr.registration }) }
  ]
  if (tr.tat_licence) list.push({ key: 'tat', text: t('public.trust_row.tat', { no: tr.tat_licence }) })
  list.push(
    { key: 'insured', text: t('public.trust_row.insured') },
    { key: 'reply',   text: t('public.trust_row.reply', { hours: tr.hours }) },
    { key: 'prepay',  text: t('public.trust_row.prepay') }
  )
  return list
})
</script>

<template>
  <ul class="trow" :aria-label="t('public.trust_row.aria')">
    <li v-for="i in items" :key="i.key" class="trow__item"><i aria-hidden="true" />{{ i.text }}</li>
  </ul>
</template>

<style scoped>
.trow { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: 0.5rem 1.6rem; align-items: center; font-size: 0.9rem; color: var(--inkSoft); }
.trow__item { display: inline-flex; align-items: center; gap: 0.55rem; white-space: nowrap; }
.trow__item i { width: 0.45rem; height: 0.45rem; border-radius: 50%; background: var(--gold, var(--warn)); flex: none; }
/* One swipeable line on a phone: the row costs 40px, not a block. */
@media (max-width: 48rem) {
  .trow { flex-wrap: nowrap; overflow-x: auto; scrollbar-width: none; -webkit-overflow-scrolling: touch; padding-bottom: 0.25rem; font-size: 0.85rem; }
  .trow::-webkit-scrollbar { display: none; }
}
</style>
